var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file 按钮
 * @author (zhanghao14)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { noop } from '../../common/util';
import classnames from 'classnames';
import { classPrefix } from '../../common/util';

import './Button.less';

/**
 * 参数说明
 * className         可选，自定义样式类名
 * classPrefix       可选，类名前缀
 * disabled          可选，是否禁用
 * label             可选，按钮上显示的文字
 * title             可选，鼠标悬浮在按钮上时提示的文字
 * type              可选，按钮类型，支持button/submit/reset
 * styleType         可选，按钮样式类型
 * skin              可选，按钮颜色主题，支持blue/purple, 默认blue
 * name              可选，按钮域名，如果组件在表单中，此属性等同于原生dom的name属性
 * value             可选，按钮的值，此属性会通过onClick回调回传
 * onClick           必选，按钮被点击时触发
 * onMouseEnter      可选，鼠标滑入按钮时触发
 * onMouseLeave      可选，鼠标滑出按钮时触发
 */

var Button = function (_Component) {
    _inherits(Button, _Component);

    function Button(props) {
        _classCallCheck(this, Button);

        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

        _this.state = {};
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(Button, [{
        key: 'onClick',
        value: function onClick(e) {
            if (this.props.disabled) {
                return;
            }
            this.props.onClick(e);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var _props = this.props,
                classPrefix = _props.classPrefix,
                name = _props.name,
                value = _props.value,
                title = _props.title,
                label = _props.label,
                disabled = _props.disabled,
                type = _props.type,
                className = _props.className,
                styleType = _props.styleType,
                skin = _props.skin,
                onMouseEnter = _props.onMouseEnter,
                onMouseLeave = _props.onMouseLeave;

            var inputProps = {
                type: 'button;submit;reset;'.indexOf(type + ';') > -1 ? type : 'button',
                name: name,
                value: label,
                disabled: disabled
            };
            var containerClassName = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-button', true), _defineProperty(_classnames, classPrefix + '-button-' + styleType, true), _defineProperty(_classnames, classPrefix + '-button-' + styleType + '-disabled', disabled), _defineProperty(_classnames, classPrefix + '-button-' + styleType + '-' + skin, true), _defineProperty(_classnames, className, true), _classnames));
            var containerProps = {
                onClick: this.onClick,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                value: value,
                title: title,
                className: containerClassName
            };
            return React.createElement(
                'div',
                containerProps,
                this.props.icon && React.createElement(
                    'span',
                    null,
                    'icon \u5F85\u6DFB\u52A0 '
                ),
                React.createElement('input', inputProps)
            );
        }
    }]);

    return Button;
}(Component);

export default Button;


Button.defaultProps = {
    // base
    skin: '',
    className: '',
    style: {},
    disabled: false,
    classPrefix: classPrefix,
    // self
    label: 'Button',
    title: '',
    icon: '',
    iconLeft: 10,
    type: 'button',
    styleType: 'normal',
    name: '',
    value: '',
    onClick: noop,
    onMouseEnter: noop,
    onMouseLeave: noop
};

Button.propTypes = {
    skin: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    classPrefix: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.node,
    title: PropTypes.string,
    icon: PropTypes.string,
    iconLeft: PropTypes.number,
    type: PropTypes.string,
    styleType: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func
};